import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { combineLatest, filter, map, pipe, switchMap, takeUntil } from 'rxjs';

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LastSeenServiceService } from 'ZalamoLibrary/src/lib/zalamo/last-seen-helper/last-seen-service.service';
import { ZalamoObject } from 'ZalamoLibrary/src/lib/zalamo/last-seen-helper/graphql';
import { MinePublicSessionsGQL } from '../../../../graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';

import { Router } from '@angular/router';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';

@Component({
  selector: 'app-last-seen-public-sessions',
  templateUrl: './last-seen-public-sessions.component.html',
  styleUrls: ['./last-seen-public-sessions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LastSeenPublicSessionsComponent implements OnInit {
  lastSeen$ = combineLatest([
    this.organizationService.getCurrentOrganization().pipe(
      switchMap((organizationId) =>
        this.minePublicSessionsGQL
          .watch({ variables: { organizationId } })
          .valueChanges.pipe(
            throwOnQueryError,
            filter(hasCompleteQueryData),
            map((result) => result.data['getPublicSessions']['sessions']),
          ),
      ),
    ),
    this.lastSeenServiceService.getLastObjectViews(ZalamoObject.PublicSession),
  ]).pipe(
    map(([allSessions, lastSeenSessions]) =>
      lastSeenSessions
        .map((publicSessionId) => ({
          publicSessionId,
          name: allSessions.find(
            (session) => session.publicSessionId === publicSessionId,
          )?.name,
        }))
        .filter((session) => !!session.name),
    ),
  );

  constructor(
    private lastSeenServiceService: LastSeenServiceService,
    private minePublicSessionsGQL: MinePublicSessionsGQL,
    private organizationService: OrganizationService,
    private zalamoDialogService: ZalamoDialogService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  async addSession() {
    console.log('Add New Public Session');
    const { AddPublicSessionComponent } =
      await import('../../../modules/public-session/views/add-public-session/add-public-session.component');
    const ref = this.zalamoDialogService.openFull(AddPublicSessionComponent);
    this.router.events
      .pipe(takeUntil(ref.beforeClosed()))
      .subscribe(() => ref.close());
  }
}
